import React from 'react';
import { type BottomTabBarProps } from '@react-navigation/bottom-tabs';
import { BottomTabBarContainer, BottomTabBarItem } from 'shared/src/component';
import {
  Colors,
  IconTapbarIconCategoryFilledNew,
  IconTapbarIconCategoryNew,
  IconTapbarIconContentsFilledNew,
  IconTapbarIconContentsNew,
  IconTapbarIconFastTruck,
  IconTapbarIconFastTruckFilled,
  IconTapbarIconHeartFilledNew,
  IconTapbarIconHeartNew,
  IconTapbarIconHomeFilledNew,
  IconTapbarIconHomeNew,
  IconTapbarIconMypageFilledNew,
  IconTapbarIconMypageNew,
  useScreenSize,
} from '@banhala/ui-kit';
import { isNotNil } from 'shared/src/utils';

const TAB_BAR_ICON_SIZE = 24;

type IconParams = React.FC<{ size: number; fill: string }>;

const IconSet: { [key: string]: { normal: IconParams; focused: IconParams } } =
  {
    Home: {
      normal: IconTapbarIconHomeNew,
      focused: IconTapbarIconHomeFilledNew,
    },
    Category: {
      normal: IconTapbarIconCategoryNew,
      focused: IconTapbarIconCategoryFilledNew,
    },
    TodayShipping: {
      normal: IconTapbarIconFastTruck,
      focused: IconTapbarIconFastTruckFilled,
    },
    Contents: {
      normal: IconTapbarIconContentsNew,
      focused: IconTapbarIconContentsFilledNew,
    },
    Like: {
      normal: IconTapbarIconHeartNew,
      focused: IconTapbarIconHeartFilledNew,
    },
    MyPage: {
      normal: IconTapbarIconMypageNew,
      focused: IconTapbarIconMypageFilledNew,
    },
  };

const TabBarIcon: React.FC<{
  name: 'Home' | string;
  focused: boolean;
}> = props => {
  if (isNotNil(IconSet[props.name])) {
    const Component = IconSet[props.name][props.focused ? 'focused' : 'normal'];
    return (
      <Component
        size={TAB_BAR_ICON_SIZE}
        fill={props.focused ? Colors.content_primary : Colors.content_secondary}
      />
    );
  }

  return null;
};

export const BottomTabBar: React.FC<BottomTabBarProps> = props => {
  const { width: screenWidth } = useScreenSize();

  return (
    <BottomTabBarContainer width={screenWidth}>
      {props.state.routes.map((route, index) => {
        const state = props.state;
        const { options: screenOptions } = props.descriptors[route.key];
        const isFocused = state.index === index;

        return (
          <BottomTabBarItem
            name={
              (screenOptions.tabBarLabel as string | undefined) ??
              route.name ??
              ''
            }
            key={route.name}
            focused={isFocused}
            icon={<TabBarIcon name={route.name} focused={isFocused} />}
            onPress={() => {
              const event = props.navigation.emit({
                type: 'tabPress',
                target: route.key,
                canPreventDefault: true,
              });

              if (!isFocused && !event.defaultPrevented) {
                props.navigation.navigate(route.name, route.params);
              }
            }}
          />
        );
      })}
    </BottomTabBarContainer>
  );
};
